import { useLang } from "./i18n";
import translations from "./translations";

export function useT() {
  const { lang } = useLang();

  const get = (path) => {
    const keys = path.split(".");
    let val = translations;
    for (const k of keys) {
      if (!val || !val[k]) return path;
      val = val[k];
    }
    if (val && typeof val === "object" && (val.en || val.de)) {
      return val[lang] || val.en;
    }
    return val;
  };

  return { t: get, lang };
}
